import { Injectable } from '@angular/core';
import { HttpServices } from '../../../../../shared/services/http-service.service';
import { SmallUnitadminDTO } from '../models/small-units-admin.model';
import { SmallUnitService } from '../models/small-units-service.model';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SmallUnitsAdminService {

    constructor(private http: HttpServices, private _http: HttpClient) {

    }
    AddReviewerDecision(data: SmallUnitadminDTO) {
        return this.http.post('SmallUnits/SmallUnitsReviewDecision', data);
    }
    AddMeasurementFeesDecision(data: SmallUnitadminDTO) {
        return this.http.post('SmallUnits/MeasurementFeesDecision', data);
    }
    AddConfirmArrivalDecision(data: SmallUnitadminDTO) {
        return this.http.post('SmallUnits/MarineVesselArrival', data);
    }
    AddIsmConfirmArrivalDecision(data: SmallUnitadminDTO) {
        return this.http.post('SmallUnits/ISMVesselArrival', data);
    }

    AddMeasurementActualDecision(data: SmallUnitadminDTO) {
        return this.http.post('SmallUnits/MeasurementActualDecision', data);
    }
    SmallUnitsConfirmDocument(data: SmallUnitadminDTO) {
        return this.http.post('SmallUnits/ConfirmDocument', data);
    }
    ConfirmPayment(data: SmallUnitadminDTO) {
        return this.http.post('SmallUnits/TreasuryConfirmation', data);
    }
    AddFinalFees(data: SmallUnitadminDTO) {
        return this.http.post('SmallUnits/FinanceFinalFees', data);
    }

    SmallUnitsTransitDecision(data: SmallUnitadminDTO) {
        return this.http.post('SmallUnits/SmallUnitsTransitDecision', data);
    }

    
    
    ISMDepatureRequest(data: SmallUnitadminDTO) {
        return this.http.post('SmallUnits/ISMDepatureRequest', data);
    }

                                                                                                                                                                         

    TransitApprovalDecision(data: SmallUnitadminDTO) {
        return this.http.post('SmallUnits/ISSmallUnitsApprovalDecision', data);
    }

    ConfirmTransitDecision(data: SmallUnitadminDTO) {
        return this.http.post('SmallUnits/SmallUnitsConfirmTransitDecision', data);
    }

    ISMDepartureApprovalDecision(data: SmallUnitadminDTO) {
        return this.http.post('SmallUnits/ISMDepartureApprovalDecision', data);
    }

    ISMConfirmTransitDecision(data: SmallUnitadminDTO) {
        return this.http.post('SmallUnits/ISMConfirmTransitDecision', data);
    }
}